import React, { forwardRef, useMemo } from 'react';
import { css, cx } from '@emotion/css';
import { theme, expandFontTheme } from '@contrast-security-inc/design-system-foundations';
import { ErrorInput } from '../InputModules/Error';
import { v4 as uuidv4 } from 'uuid';
const containerStyle = (allGroupDirection) => css `
  display: flex;
  flex-flow: ${allGroupDirection ?? 'column'};
  ${allGroupDirection === 'row' &&
    css `
      align-items: center; gap: 16px;

      label {
        margin-bottom: 0;
        padding-bottom: 0;
      }
    `}
`;
const baseStyle = (allGroupDirection, radioGroupDirection) => css `
  background: ${theme.color.white};
  border-radius: 4px;
  display: flex;
  flex-flow: ${allGroupDirection ?? radioGroupDirection};
  /* stylelint-disable-next-line */
  gap: ${allGroupDirection === 'row' || (allGroupDirection !== 'column' && radioGroupDirection === 'row') ? '16px' : '8px'};
`;
const labelStyle = (color) => css `
  ${expandFontTheme(theme.font.titleH5)}
  padding-bottom: 16px;
  color: ${theme.color[color]};
`;
export const RadioGroup = forwardRef(({ children, className, error, groupRef, isDisabled, label, name, style, testId, allGroupDirection, // don't default for style check above
radioGroupDirection = 'column', ...rest }, ref) => {
    const uniqueId = useMemo(() => name || uuidv4(), [name]);
    return (React.createElement("div", { className: cx(containerStyle(allGroupDirection), className, 'ds-radio-group'), style: style, "data-testid": testId, ...rest, ref: groupRef ?? ref },
        label && (React.createElement("label", { id: name, className: labelStyle(isDisabled ? 'neutral60' : 'neutral100'), "data-testid": testId && `${testId}-label` }, label)),
        React.createElement("div", { className: baseStyle(allGroupDirection, radioGroupDirection), role: "radiogroup", "aria-labelledby": name, "data-testid": testId && `${testId}-group` },
            React.Children.map(children, (child) => React.isValidElement(child) &&
                React.cloneElement(child, {
                    name,
                    isDisabled,
                    useInlineError: false,
                })),
            error && React.createElement(ErrorInput, { id: uniqueId, error: error, testId: testId }))));
});
RadioGroup.displayName = 'RadioGroup';
